import {
  Avatar,
  InputAdornment,
  TextField,
  Tooltip,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import AddIcon from "@mui/icons-material/Add";
import React, { useMemo, useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { s3baseUrl } from "src/config/config";
import { Icon } from "@iconify/react";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import ModalToShowAnExerciseInfo from "../Workout/components/ModalToShowAnExerciseInfo";
import {
  formatWithLeadingZeros,
  getKmhrForPace,
  getMihrForPace,
  getPaceText,
  getPaceTextinPaces,
} from "src/utils/constant";

const EMOMExercisesUI = ({
  addArray,
  setaddArray,
  memberId,
  mainindex,
  message,
  isPersonal,
  isSidebar,
  isWithHistoryAndBigScreen,
}) => {
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");
  const smallScreen = window.innerWidth <= 450;
  const [selectedRound, setSelectedRound] = useState(1);
  const [updatedIndexesArray, setUpdatedIndexesArray] = useState([]);

  const handleArrowSuperSet = (value, index, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["open"] = value;

    setaddArray(list);
  };

  const getRounds = (count) => {
    const rounds = [];
    for (let i = 1; i <= count; i++) {
      rounds.push(
        <div
          onClick={() => {
            setSelectedRound(i);
          }}
          className={
            selectedRound == i
              ? "emom-round-count-box me-2 mt-2"
              : "emom-round-count-box-disable me-2 mt-2"
          }
        >
          <div
            className={
              selectedRound == i
                ? "emom-round-count"
                : "emom-round-count-disable"
            }
          >
            {i}
          </div>
        </div>,
      );
    }
    return rounds;
  };

  const getMinutesForEmom = () => {
    let min = 10;
    let sec = 0;
    const list = [...addArray];
    const rounds = list[mainindex].rounds;
    const moments = list[mainindex].emomSets.length;
    const interval = list[mainindex].time_interval;
    min = formatWithLeadingZeros(
      Math.floor((rounds * moments * interval) / 60),
    );
    sec = formatWithLeadingZeros((rounds * moments * interval) % 60);

    return `${
      Math.floor(interval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(interval % 60) +
      " " +
      "minute" +
      " " +
      "for" +
      " " +
      min +
      ":" +
      sec
    }`;
  };

  const getMinutesForInterval = (index) => {
    const list = [...addArray];
    const interval = list[mainindex].time_interval;

    if (interval <= 60) {
      return index + 1;
    }
    if (interval % 60 == 0) {
      return `${
        (interval / 60) * index +
        1 +
        " – " +
        ((interval / 60) * index + interval / 60)
      }`;
    }
    let startInterval = interval * index;
    let endtInterval = interval * index + interval;
    let startintervalText =
      interval * index
        ? Math.floor(startInterval / 60) +
          " " +
          ":" +
          formatWithLeadingZeros(startInterval % 60)
        : 0;
    let endIntervalText =
      Math.floor(endtInterval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(endtInterval % 60);

    return `${startintervalText + " – " + endIntervalText}`;
  };

  useMemo(() => {
    const arraylength = addArray[mainindex].emomSets.length;
    const lastIndex = parseInt(selectedRound) * arraylength;
    const startingIndex = lastIndex - (arraylength - 1);
    let finalArray = [];
    for (let index = startingIndex; index <= lastIndex; index++) {
      finalArray.push(index - 1);
    }
    setUpdatedIndexesArray(finalArray);
  }, [selectedRound]);

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  return (
    <div className="my-2">
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      <div className="characters mt-2">
        <div
          style={{ position: "relative" }}
          className="workout-Superset-card my-1"
        >
          <Box>
            <div className="row mb-3">
              <div
                className={`col-sm-12 col-md-2 col-lg-2 order-2 order-md-1 text-center text-md-start`}
              >
                <Tooltip placement="top" title={message}>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    label="Interval Duration"
                    InputLabelProps={{
                      className: "textfiels-input-label",
                      shrink: true,
                      style: { fontSize: "14px" },
                    }}
                    InputProps={{
                      className: "textfiels-input-value",
                      style: {
                        fontSize: "13px",
                        paddingLeft: "0px",
                        paddingRight: "0px",

                        justifyContent: "center",
                      },
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <TextField
                            id="outlined-basic-minutes"
                            type="number"
                            size="small"
                            placeholder="Min"
                            value={formatWithLeadingZeros(
                              Math.floor(
                                addArray[mainindex].time_interval / 60,
                              ),
                            )}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "19px",
                                fontWeight: "500",
                              },
                              readOnly: true,
                            }}
                            sx={{
                              "& fieldset": {
                                border: "none",
                              },
                              "& input": {
                                textAlign: "center",
                                padding: "0px",
                              },
                              width: "100%",
                            }}
                          />
                          <div className="fs-4 fw-semibold ">:</div>

                          <TextField
                            id="outlined-basic-seconds"
                            type="number"
                            size="small"
                            placeholder="Sec"
                            value={formatWithLeadingZeros(
                              addArray[mainindex].time_interval % 60,
                            )}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "19px",
                                fontWeight: "500",
                              },
                              readOnly: true,
                            }}
                            sx={{
                              "& fieldset": {
                                border: "none",
                              },
                              "& input": {
                                textAlign: "center",
                                padding: "0px",
                              },
                              width: "100%",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      borderRadius: "5px",
                      fontSize: "13px",
                      "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          width: "0px !important",
                          padding: "9px 0px !important",
                        },
                      "& .css-1nuss9t": {
                        width: "0px !important",
                        padding: "9px 0px !important",
                      },
                      width: "110px",
                    }}
                  />
                </Tooltip>
              </div>
              <div className={`col-sm-12 col-md-8 col-lg-8 order-3 order-md-2`}>
                {smallScreen ? (
                  <div className="my-2 text-center">
                    <div style={{ whiteSpace: "nowrap" }}>
                      Every {getMinutesForEmom()} minutes{" "}
                    </div>
                    <div className="d-flex align-items-center justify-content-center  ">
                      <div className="ms-2 cross-icon ">
                        <RemoveCircleIcon className="diary-icon-plus-minus" />
                      </div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        placeholder="Rounds"
                        type="number"
                        value={addArray[mainindex].rounds}
                        name="superset_sets"
                        disabled
                        InputLabelProps={{
                          className: "textfiels-input-label",
                          shrink: true,
                          style: { fontSize: "14px" },
                        }}
                        InputProps={{
                          className: "textfiels-input-value",
                          style: { fontSize: "13px", padding: "0" },
                        }}
                        sx={{
                          mx: 1,
                          borderRadius: "5px",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          fontSize: "13px",
                          "& input": {
                            padding: "3px 5px",
                            textAlign: "center",
                          },
                          width: "33px",
                        }}
                      />

                      <div className=" cross-icon me-2">
                        <AddCircleIcon className="diary-icon-plus-minus" />
                      </div>
                      <div>rounds</div>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center justify-content-center  my-2">
                    <div style={{ whiteSpace: "nowrap" }}>
                      Every {getMinutesForEmom()} minutes{" "}
                    </div>
                    <div className="d-flex align-items-center justify-content-center  ">
                      <div className="ms-2 cross-icon ">
                        <RemoveCircleIcon className="diary-icon-plus-minus" />
                      </div>
                      <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        placeholder="Rounds"
                        type="number"
                        value={addArray[mainindex].rounds}
                        name="superset_sets"
                        disabled
                        InputLabelProps={{
                          className: "textfiels-input-label",
                          shrink: true,
                          style: { fontSize: "14px" },
                        }}
                        InputProps={{
                          className: "textfiels-input-value",
                          style: { fontSize: "13px", padding: "0" },
                        }}
                        sx={{
                          mx: 1,
                          borderRadius: "5px",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          fontSize: "13px",
                          "& input": {
                            padding: "3px 5px",
                            textAlign: "center",
                          },
                          width: "33px",
                        }}
                      />

                      <div className=" cross-icon me-2">
                        <AddCircleIcon className="diary-icon-plus-minus" />
                      </div>
                      <div>rounds</div>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-sm-12 col-md-2 col-lg-2  cross-icon order-1 order-md-3 d-flex justify-content-end">
                <>
                  <Tooltip placement="top" title={message}>
                    <RemoveCircleOutlineIcon className="diary-icon-remove" />
                  </Tooltip>
                </>

                <Tooltip placement="top" title={message}>
                  <AddCircleOutlineIcon className="diary-icon-add" />
                </Tooltip>

                <Tooltip placement="top" title={message}>
                  <span>
                    <CustomPopoverSection menu={[]} data={mainindex} />
                  </span>
                </Tooltip>
              </div>
              {isPersonal && (
                <div className="col-12 order-4  ">
                  <div
                    className="d-flex align-items-center justify-content-center "
                    style={{ flexWrap: "wrap" }}
                  >
                    <div className="emom-round-title mt-2">Rounds: </div>
                    {getRounds(addArray[mainindex].rounds)}
                  </div>
                </div>
              )}
            </div>
            <TextField
              id="outlined-basic"
              size="small"
              variant="outlined"
              placeholder="Instructions"
              label="Instructions"
              type="number"
              value={addArray[mainindex].description}
              name="description"
              multiline
              rows={2}
              InputLabelProps={{
                className: "textfiels-input-label",
                shrink: true,
                style: { fontSize: "14px" },
              }}
              InputProps={{
                className: "textfiels-input-value",
                style: { fontSize: "14px" },
              }}
              sx={{
                borderRadius: "5px",
                mt: 2,
                width: "100%",
              }}
            />
            {addArray[mainindex].emomSets.length > 0 &&
              addArray[mainindex].emomSets.map((item, index) => {
                return (
                  <div className=" my-2 ">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div>
                        Minute{" "}
                        {getMinutesForInterval(updatedIndexesArray[index])}
                      </div>
                    </div>

                    {item.length > 0 &&
                      item.map((exerData, exerIndex) => {
                        return (
                          <div className="ms-4 mt-1">
                            <div
                              className="d-flex workout-set-card  "
                              style={{
                                width: "100%",
                                position: "relative",
                                overflow: "hidden",
                              }}
                            >
                              <Box
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                }}
                              >
                                <div className="row  ">
                                  <div
                                    className={`col-sm-12 ${"col-md-6"} col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0 `}
                                  >
                                    <div className="exercise-label-box">
                                      <span className="outer-label">
                                        Exercise
                                      </span>
                                      <div className="d-flex align-items-center justify-content-between">
                                        <Tooltip
                                          placement="top"
                                          touch="on"
                                          title={message}
                                        >
                                          <div className="w-100">
                                            <div className="exercise-label w-100">
                                              <div className="d-flex align-items-center">
                                                {exerData?.exercise?.image
                                                  ?.thumbnail_3 && (
                                                  <Avatar
                                                    sx={{
                                                      borderRadius: "5px",
                                                    }}
                                                    alt="User Image"
                                                    src={
                                                      s3baseUrl +
                                                      exerData?.exercise?.image
                                                        ?.thumbnail_3
                                                    }
                                                  />
                                                )}
                                                <div className="label-text ms-1">
                                                  {exerData?.exercise?.title
                                                    ? exerData?.exercise?.title
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Tooltip>
                                        <div className="exercise-action">
                                          <div style={{ fontSize: "16px" }}>
                                            {exerData?.exercise ? (
                                              <div>
                                                <InfoIcon
                                                  onClick={() =>
                                                    handleClickOpen(
                                                      exerData?.exercise?._id,
                                                    )
                                                  }
                                                  className="d-block"
                                                  fontSize="14px"
                                                  sx={{
                                                    opacity: 0.5,
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </div>
                                            ) : (
                                              <AddIcon
                                                sx={{
                                                  opacity: 0.5,
                                                  cursor: "pointer",
                                                }}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <Button
                                      sx={{ textTransform: "inherit" }}
                                      size="small"
                                      color="primary"
                                      variant="contained"
                                      className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                      onClick={() => {
                                        handleArrowSuperSet(
                                          !exerData?.open ? true : false,
                                          index,
                                          exerIndex,
                                        );
                                      }}
                                    >
                                      {!exerData?.open ? (
                                        <KeyboardArrowDownIcon
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                          }}
                                        />
                                      ) : (
                                        <KeyboardArrowUpIcon
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                          }}
                                        />
                                      )}

                                      <Typography
                                        variant="body2"
                                        sx={{
                                          // opacity: 0.6,
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {` Sets ${1}`}
                                      </Typography>
                                    </Button>
                                  </div>

                                  <div
                                    className={`col-sm-12 ${"col-md-5"} col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0  d-flex align-items-center justify-content-start `}
                                  >
                                    <div className="d-flex align-items-center mx-1">
                                      <Tooltip
                                        touch="on"
                                        placement="top"
                                        title={message}
                                      >
                                        <div className="d-flex align-items-center ms-3 set-parameters ">
                                          <Icon
                                            icon="pajamas:labels"
                                            fontSize="10px"
                                          />
                                          <Typography
                                            variant="body2"
                                            sx={{ ml: 0.5 }}
                                          >
                                            {`Parameters`}
                                          </Typography>
                                        </div>
                                      </Tooltip>
                                    </div>
                                  </div>
                                </div>

                                {
                                  exerData?.open && (
                                    // exerData?.set?.map((item, setIndex) => (
                                    <div className="d-flex align-items-center my-3 workout-card-inset">
                                      <Tooltip placement="top" title={message}>
                                        <div className="row w-100">
                                          {exerData.parameters.includes(
                                            "Vdot",
                                          ) && (
                                            <>
                                              {memberId && (
                                                <div
                                                  className={
                                                    isWithHistoryAndBigScreen
                                                      ? "col-2 pe-0 py-1"
                                                      : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                                                  }
                                                >
                                                  <TextField
                                                    id="outlined-basic"
                                                    size="small"
                                                    variant="outlined"
                                                    placeholder="0"
                                                    type="number"
                                                    label="Auto Pacer"
                                                    value={
                                                      exerData.set[
                                                        selectedRound - 1
                                                      ].vdot
                                                        ? exerData.set[
                                                            selectedRound - 1
                                                          ].vdot
                                                        : ""
                                                    }
                                                    name="vdot"
                                                    readOnly
                                                    InputLabelProps={{
                                                      className:
                                                        "textfiels-input-label",
                                                      shrink: true,
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                    }}
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "13px",
                                                        paddingLeft: "0px",
                                                        paddingRight: "5px",
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    sx={{
                                                      borderRadius: "5px",
                                                      fontSize: "13px",
                                                      width: "100%",
                                                      marginTop: "5px",
                                                    }}
                                                  />
                                                </div>
                                              )}
                                              <div
                                                className={
                                                  isWithHistoryAndBigScreen
                                                    ? "col-5 pe-0 py-1"
                                                    : `col-12 col-md-5 ${
                                                        isSidebar
                                                          ? "col-lg-4"
                                                          : "col-lg-3"
                                                      } pe-0 py-1`
                                                }
                                              >
                                                <TextField
                                                  id="outlined-basic"
                                                  variant="outlined"
                                                  label="Type"
                                                  readOnly
                                                  InputLabelProps={{
                                                    className:
                                                      "textfiels-input-label",
                                                    shrink: true,
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    readOnly: true,
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingLeft: "0px",
                                                      paddingRight: "0px",

                                                      justifyContent: "center",
                                                    },
                                                    endAdornment: (
                                                      <InputAdornment
                                                        position="end"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Select
                                                          id="select-option"
                                                          variant="outlined"
                                                          size="small"
                                                          name="race_type"
                                                          readOnly
                                                          value={
                                                            exerData.set[
                                                              selectedRound - 1
                                                            ].race_type
                                                              ? exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].race_type
                                                              : "c"
                                                          }
                                                          label="Weight Type"
                                                          inputProps={{
                                                            style: {
                                                              padding: 0,
                                                            },
                                                          }}
                                                          sx={{
                                                            "& legend": {
                                                              display: "none",
                                                            },
                                                            "& fieldset": {
                                                              top: 0,
                                                            },
                                                            fontSize: "13px",
                                                            border: "none",
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            "& .MuiOutlinedInput-input":
                                                              {
                                                                padding: 0,
                                                              },
                                                          }}
                                                        >
                                                          <MenuItem value="el">
                                                            Easy/Long
                                                          </MenuItem>
                                                          <MenuItem value="c">
                                                            Compromised
                                                          </MenuItem>
                                                          <MenuItem value="t">
                                                            Threshold
                                                          </MenuItem>
                                                          <MenuItem value="i">
                                                            Interval
                                                          </MenuItem>
                                                          <MenuItem value="r">
                                                            Repitition
                                                          </MenuItem>
                                                        </Select>

                                                        <Select
                                                          id="select-option"
                                                          variant="outlined"
                                                          size="small"
                                                          name="pace_type"
                                                          readOnly
                                                          value={
                                                            exerData.set[
                                                              selectedRound - 1
                                                            ].pace_type
                                                              ? exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].pace_type
                                                              : ""
                                                          }
                                                          label="Weight Type"
                                                          inputProps={{
                                                            style: {
                                                              padding: 0,
                                                            },
                                                          }}
                                                          sx={{
                                                            "& legend": {
                                                              display: "none",
                                                            },
                                                            "& fieldset": {
                                                              top: 0,
                                                            },
                                                            fontSize: "13px",
                                                            border: "none",
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            "& .MuiOutlinedInput-input":
                                                              {
                                                                padding: 0,
                                                              },
                                                          }}
                                                        >
                                                          {exerData.set[
                                                            selectedRound - 1
                                                          ]?.optionsType?.map(
                                                            (option) => {
                                                              return (
                                                                <MenuItem
                                                                  key={
                                                                    option?.key
                                                                  }
                                                                  value={
                                                                    option?.key
                                                                  }
                                                                >
                                                                  {
                                                                    option?.title
                                                                  }
                                                                </MenuItem>
                                                              );
                                                            },
                                                          )}
                                                        </Select>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  sx={{
                                                    borderRadius: "5px",
                                                    fontSize: "13px",

                                                    marginTop: "5px",
                                                    "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                      {
                                                        width: "0px !important",
                                                        padding:
                                                          "9px 0px !important",
                                                      },
                                                    "& .css-1nuss9t": {
                                                      width: "0px !important",
                                                      padding:
                                                        "9px 0px !important",
                                                    },

                                                    width: "100%",
                                                  }}
                                                />
                                              </div>
                                              {exerData.parameters.includes(
                                                "Distance",
                                              ) && (
                                                <div
                                                  className={
                                                    isWithHistoryAndBigScreen
                                                      ? "col-3 pe-0 py-2"
                                                      : `col-12 col-md-3 col-lg-2 pe-0 py-2`
                                                  }
                                                >
                                                  <TextField
                                                    sx={{
                                                      borderRadius: "5px",
                                                      paddingRight: 0,
                                                      width: "100%",
                                                    }}
                                                    size="small"
                                                    readOnly
                                                    id="custom-input"
                                                    variant="outlined"
                                                    placeholder={"Distance"}
                                                    name="distance"
                                                    label="Distance"
                                                    value={
                                                      exerData.set[
                                                        selectedRound - 1
                                                      ].distance
                                                        ? exerData.set[
                                                            selectedRound - 1
                                                          ].distance
                                                        : ""
                                                    }
                                                    type="number"
                                                    InputLabelProps={{
                                                      className:
                                                        "textfiels-input-label",
                                                      shrink: true,
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                    }}
                                                    InputProps={{
                                                      readOnly: true,
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "13px",
                                                        paddingRight: 0,
                                                      },
                                                      endAdornment: (
                                                        <InputAdornment position="end">
                                                          <Select
                                                            id="select-option"
                                                            variant="outlined"
                                                            size="small"
                                                            readOnly
                                                            name="distanceType"
                                                            value={
                                                              exerData.set[
                                                                selectedRound -
                                                                  1
                                                              ]?.distanceType
                                                            }
                                                            label="Weight Type"
                                                            sx={{
                                                              "& legend": {
                                                                display: "none",
                                                              },
                                                              "& fieldset": {
                                                                top: 0,
                                                              },
                                                              fontSize: "13px",
                                                              border: "none",
                                                              "& fieldset": {
                                                                border: "none",
                                                              },
                                                            }}
                                                          >
                                                            <MenuItem value="m">
                                                              Meter
                                                            </MenuItem>
                                                            <MenuItem value="km">
                                                              KM
                                                            </MenuItem>
                                                            <MenuItem value="mi">
                                                              Mile
                                                            </MenuItem>
                                                          </Select>
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                  />
                                                </div>
                                              )}
                                              {memberId ? (
                                                exerData.set[selectedRound - 1]
                                                  ?.race_type == "el" ? (
                                                  <div
                                                    className={
                                                      isWithHistoryAndBigScreen
                                                        ? "col-3 pe-0 py-1"
                                                        : `col-12 col-md-3 col-lg-2 pe-0 py-1`
                                                    }
                                                  >
                                                    <TextField
                                                      id="outlined-basic"
                                                      variant="outlined"
                                                      label={getPaceText(
                                                        exerData.set[
                                                          selectedRound - 1
                                                        ].pace_type
                                                          ? exerData.set[
                                                              selectedRound - 1
                                                            ].pace_type
                                                          : "",
                                                      )}
                                                      readOnly
                                                      InputLabelProps={{
                                                        className:
                                                          "textfiels-input-label",
                                                        shrink: true,
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                      }}
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "13px",
                                                          paddingLeft: "0px",
                                                          paddingRight: "0px",

                                                          justifyContent:
                                                            "center",
                                                        },
                                                        readOnly: true,
                                                        endAdornment: (
                                                          <InputAdornment
                                                            position="end"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <TextField
                                                              id="outlined-basic-minutes"
                                                              type="number"
                                                              size="small"
                                                              readOnly
                                                              placeholder="Min"
                                                              name="pace"
                                                              value={getPaceText(
                                                                exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].pace
                                                                  ? Math.floor(
                                                                      exerData
                                                                        .set[
                                                                        selectedRound -
                                                                          1
                                                                      ].pace /
                                                                        60,
                                                                    )
                                                                  : "",
                                                              )}
                                                              InputProps={{
                                                                className:
                                                                  "textfiels-input-value",
                                                                style: {
                                                                  fontSize:
                                                                    "14px",
                                                                },
                                                                readOnly: true,
                                                              }}
                                                              sx={{
                                                                "& fieldset": {
                                                                  border:
                                                                    "none",
                                                                },

                                                                "& input": {
                                                                  textAlign:
                                                                    "center",
                                                                  padding:
                                                                    "0px",
                                                                },
                                                                width: "100%",
                                                              }}
                                                            />
                                                            <div className="fs-6 fw-semibold ms-1 ">
                                                              :
                                                            </div>

                                                            <TextField
                                                              id="outlined-basic-seconds"
                                                              type="number"
                                                              size="small"
                                                              placeholder="Sec"
                                                              readOnly
                                                              name="pace"
                                                              value={formatWithLeadingZeros(
                                                                exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].pace
                                                                  ? Math.floor(
                                                                      exerData
                                                                        .set[
                                                                        selectedRound -
                                                                          1
                                                                      ].pace %
                                                                        60,
                                                                    )
                                                                  : "",
                                                              )}
                                                              InputProps={{
                                                                className:
                                                                  "textfiels-input-value",
                                                                style: {
                                                                  fontSize:
                                                                    "14px",
                                                                },
                                                                readOnly: true,
                                                              }}
                                                              sx={{
                                                                "& fieldset": {
                                                                  border:
                                                                    "none",
                                                                },

                                                                "& input": {
                                                                  textAlign:
                                                                    "center",
                                                                  padding:
                                                                    "0px",
                                                                },
                                                                width: "100%",
                                                              }}
                                                            />

                                                            <div className="fs-6 fw-semibold ms-1 me-1 ">
                                                              -
                                                            </div>

                                                            <TextField
                                                              id="outlined-basic-minutes"
                                                              type="number"
                                                              size="small"
                                                              placeholder="Min"
                                                              name="paceUp"
                                                              readOnly
                                                              value={formatWithLeadingZeros(
                                                                exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].paceUp
                                                                  ? Math.floor(
                                                                      exerData
                                                                        .set[
                                                                        selectedRound -
                                                                          1
                                                                      ].paceUp /
                                                                        60,
                                                                    )
                                                                  : "",
                                                              )}
                                                              InputProps={{
                                                                className:
                                                                  "textfiels-input-value",
                                                                style: {
                                                                  fontSize:
                                                                    "14px",
                                                                },
                                                                readOnly: true,
                                                              }}
                                                              sx={{
                                                                "& fieldset": {
                                                                  border:
                                                                    "none",
                                                                },

                                                                "& input": {
                                                                  textAlign:
                                                                    "center",
                                                                  padding:
                                                                    "0px",
                                                                },
                                                                width: "100%",
                                                              }}
                                                            />
                                                            <div className="fs-6 fw-semibold ms-1">
                                                              :
                                                            </div>
                                                            <TextField
                                                              id="outlined-basic-seconds"
                                                              type="number"
                                                              size="small"
                                                              placeholder="Sec"
                                                              name="paceUp"
                                                              readOnly
                                                              value={formatWithLeadingZeros(
                                                                exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].paceUp
                                                                  ? Math.floor(
                                                                      exerData
                                                                        .set[
                                                                        selectedRound -
                                                                          1
                                                                      ].paceUp %
                                                                        60,
                                                                    )
                                                                  : "",
                                                              )}
                                                              InputProps={{
                                                                className:
                                                                  "textfiels-input-value",
                                                                style: {
                                                                  fontSize:
                                                                    "14px",
                                                                },
                                                                readOnly: true,
                                                              }}
                                                              sx={{
                                                                "& fieldset": {
                                                                  border:
                                                                    "none",
                                                                },

                                                                "& input": {
                                                                  textAlign:
                                                                    "center",
                                                                  padding:
                                                                    "0px",
                                                                },
                                                                width: "100%",
                                                                marginRight: 1,
                                                              }}
                                                            />
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      sx={{
                                                        borderRadius: "5px",
                                                        fontSize: "13px",

                                                        marginTop: "5px",
                                                        "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                          {
                                                            width:
                                                              "0px !important",
                                                            padding:
                                                              "9px 0px !important",
                                                          },
                                                        "& .css-1nuss9t": {
                                                          width:
                                                            "0px !important",
                                                          padding:
                                                            "9px 0px !important",
                                                        },

                                                        width: "100%",
                                                      }}
                                                    />
                                                  </div>
                                                ) : (
                                                  <div
                                                    className={
                                                      isWithHistoryAndBigScreen
                                                        ? "col-2 pe-0 py-1"
                                                        : `col-12 col-md-2 col-lg-1 pe-0 py-1`
                                                    }
                                                  >
                                                    <TextField
                                                      id="outlined-basic"
                                                      variant="outlined"
                                                      readOnly
                                                      label={getPaceText(
                                                        exerData.set[
                                                          selectedRound - 1
                                                        ].pace_type
                                                          ? exerData.set[
                                                              selectedRound - 1
                                                            ].pace_type
                                                          : "",
                                                      )}
                                                      InputLabelProps={{
                                                        readOnly: true,
                                                        className:
                                                          "textfiels-input-label",
                                                        shrink: true,
                                                        style: {
                                                          fontSize: "14px",
                                                        },
                                                      }}
                                                      InputProps={{
                                                        className:
                                                          "textfiels-input-value",
                                                        style: {
                                                          fontSize: "13px",
                                                          paddingLeft: "0px",
                                                          paddingRight: "0px",

                                                          justifyContent:
                                                            "center",
                                                        },
                                                        readOnly: true,
                                                        endAdornment: (
                                                          <InputAdornment
                                                            position="end"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            <TextField
                                                              id="outlined-basic-minutes"
                                                              type="number"
                                                              readOnly
                                                              size="small"
                                                              placeholder="Min"
                                                              name="pace"
                                                              value={formatWithLeadingZeros(
                                                                exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].pace
                                                                  ? Math.floor(
                                                                      exerData
                                                                        .set[
                                                                        selectedRound -
                                                                          1
                                                                      ].pace /
                                                                        60,
                                                                    )
                                                                  : "",
                                                              )}
                                                              InputProps={{
                                                                className:
                                                                  "textfiels-input-value",
                                                                style: {
                                                                  fontSize:
                                                                    "14px",
                                                                },
                                                                readOnly: true,
                                                              }}
                                                              sx={{
                                                                "& fieldset": {
                                                                  border:
                                                                    "none",
                                                                },

                                                                "& input": {
                                                                  textAlign:
                                                                    "center",
                                                                  padding:
                                                                    "0px",
                                                                },
                                                                width: "100%",
                                                              }}
                                                            />
                                                            <div className="fs-6 fw-semibold ms-1 ">
                                                              :
                                                            </div>

                                                            <TextField
                                                              id="outlined-basic-seconds"
                                                              type="number"
                                                              size="small"
                                                              placeholder="Sec"
                                                              readOnly
                                                              name="pace"
                                                              value={formatWithLeadingZeros(
                                                                exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].pace
                                                                  ? Math.floor(
                                                                      exerData
                                                                        .set[
                                                                        selectedRound -
                                                                          1
                                                                      ].pace %
                                                                        60,
                                                                    )
                                                                  : "",
                                                              )}
                                                              InputProps={{
                                                                className:
                                                                  "textfiels-input-value",
                                                                style: {
                                                                  fontSize:
                                                                    "14px",
                                                                },
                                                                readOnly: true,
                                                              }}
                                                              sx={{
                                                                "& fieldset": {
                                                                  border:
                                                                    "none",
                                                                },

                                                                "& input": {
                                                                  textAlign:
                                                                    "center",
                                                                  padding:
                                                                    "0px",
                                                                },
                                                                width: "100%",
                                                              }}
                                                            />
                                                          </InputAdornment>
                                                        ),
                                                      }}
                                                      sx={{
                                                        borderRadius: "5px",
                                                        fontSize: "13px",
                                                        "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                          {
                                                            width:
                                                              "0px !important",
                                                            padding:
                                                              "9px 0px !important",
                                                          },
                                                        "& .css-1nuss9t": {
                                                          width:
                                                            "0px !important",
                                                          padding:
                                                            "9px 0px !important",
                                                        },
                                                        // "& input": {
                                                        //   textAlign: "center",
                                                        //   padding: "0px",
                                                        // },
                                                        width: "100%",
                                                        // flexGrow: 1,
                                                        marginTop: "5px",
                                                      }}
                                                    />
                                                  </div>
                                                )
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          )}
                                          {exerData.parameters.includes(
                                            "Pace",
                                          ) && (
                                            <>
                                              <div
                                                className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                              >
                                                <FormControl fullWidth readOnly>
                                                  <InputLabel
                                                    className="set-Type-lable"
                                                    sx={{
                                                      fontSize: "14px",
                                                    }}
                                                    id="demo-simple-select-label"
                                                  >
                                                    Type
                                                  </InputLabel>

                                                  <Select
                                                    className="set-Type-value"
                                                    id="select-option"
                                                    variant="outlined"
                                                    size="small"
                                                    name="race_type"
                                                    readOnly
                                                    value={
                                                      exerData.set[
                                                        selectedRound - 1
                                                      ].race_type
                                                        ? exerData.set[
                                                            selectedRound - 1
                                                          ].race_type
                                                        : "c"
                                                    }
                                                    label="Type"
                                                    inputProps={{
                                                      style: {
                                                        padding: 0,
                                                      },
                                                    }}
                                                    sx={{
                                                      width: "100%",
                                                      fontSize: "13px",
                                                      "& .MuiOutlinedInput-input":
                                                        {
                                                          paddingLeft: 1,
                                                        },
                                                    }}
                                                  >
                                                    <MenuItem value="el">
                                                      Easy/Long
                                                    </MenuItem>
                                                    <MenuItem value="c">
                                                      Compromised
                                                    </MenuItem>

                                                    <MenuItem value="i">
                                                      Interval
                                                    </MenuItem>
                                                    <MenuItem value="r">
                                                      Repitition
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </div>
                                              <div
                                                className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                              >
                                                <TextField
                                                  sx={{
                                                    borderRadius: "5px",
                                                    paddingRight: 0,
                                                    width: "100%",
                                                  }}
                                                  size="small"
                                                  id="custom-input"
                                                  variant="outlined"
                                                  placeholder={"Distance"}
                                                  name="distance"
                                                  label="Distance"
                                                  value={
                                                    exerData.set[
                                                      selectedRound - 1
                                                    ].distance
                                                      ? exerData.set[
                                                          selectedRound - 1
                                                        ].distance
                                                      : ""
                                                  }
                                                  type="number"
                                                  InputLabelProps={{
                                                    className:
                                                      "textfiels-input-label",
                                                    shrink: true,
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingRight: 0,
                                                    },
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment position="end">
                                                        <Select
                                                          id="select-option"
                                                          variant="outlined"
                                                          size="small"
                                                          name="distanceType"
                                                          value={
                                                            exerData.set[
                                                              selectedRound - 1
                                                            ].distanceType
                                                              ? exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].distanceType
                                                              : ""
                                                          }
                                                          label="Weight Type"
                                                          readOnly={true}
                                                          sx={{
                                                            "& legend": {
                                                              display: "none",
                                                            },
                                                            "& fieldset": {
                                                              top: 0,
                                                            },
                                                            fontSize: "13px",
                                                            border: "none",
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                          }}
                                                        >
                                                          <MenuItem value="m">
                                                            Meter
                                                          </MenuItem>
                                                          <MenuItem value="km">
                                                            KM
                                                          </MenuItem>
                                                          <MenuItem value="mi">
                                                            Mile
                                                          </MenuItem>
                                                        </Select>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                />
                                              </div>
                                              <div
                                                className={`col-12 col-md-2 col-lg-2 pe-0 py-2`}
                                              >
                                                <TextField
                                                  id="outlined-basic"
                                                  variant="outlined"
                                                  label={getPaceTextinPaces(
                                                    exerData.set[
                                                      selectedRound - 1
                                                    ].distanceType
                                                      ? exerData.set[
                                                          selectedRound - 1
                                                        ].distanceType
                                                      : "",
                                                  )}
                                                  InputLabelProps={{
                                                    className:
                                                      "textfiels-input-label",
                                                    shrink: true,
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingLeft: "0px",
                                                      paddingRight: "0px",

                                                      justifyContent: "center",
                                                    },
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment
                                                        position="end"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <TextField
                                                          id="outlined-basic-minutes"
                                                          type="number"
                                                          size="small"
                                                          placeholder="Min"
                                                          name="pace"
                                                          value={formatWithLeadingZeros(
                                                            Math.floor(
                                                              exerData.set[
                                                                selectedRound -
                                                                  1
                                                              ].pace
                                                                ? exerData.set[
                                                                    selectedRound -
                                                                      1
                                                                  ].pace
                                                                : 0 / 60,
                                                            ),
                                                          )}
                                                          InputProps={{
                                                            className:
                                                              "textfiels-input-value",
                                                            style: {
                                                              fontSize: "14px",
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          sx={{
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                            //   {
                                                            //     padding: "0px !important",
                                                            //   },
                                                            "& input": {
                                                              textAlign:
                                                                "center",
                                                              padding: "0px",
                                                            },
                                                            width: "100%",
                                                          }}
                                                        />
                                                        <div className="fs-6 fw-semibold ms-1 ">
                                                          :
                                                        </div>

                                                        <TextField
                                                          id="outlined-basic-seconds"
                                                          type="number"
                                                          size="small"
                                                          placeholder="Sec"
                                                          name="pace"
                                                          value={formatWithLeadingZeros(
                                                            exerData.set[
                                                              selectedRound - 1
                                                            ].pace
                                                              ? exerData.set[
                                                                  selectedRound -
                                                                    1
                                                                ].pace
                                                              : 0 % 60,
                                                          )}
                                                          InputProps={{
                                                            className:
                                                              "textfiels-input-value",
                                                            style: {
                                                              fontSize: "14px",
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          sx={{
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            // "& .css-1j6hc4w-MuiInputBase-input-MuiOutlinedInput-input":
                                                            //   {
                                                            //     padding: "0px !important",
                                                            //   },
                                                            "& input": {
                                                              textAlign:
                                                                "center",
                                                              padding: "0px",
                                                            },
                                                            width: "100%",
                                                          }}
                                                        />
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  sx={{
                                                    borderRadius: "5px",
                                                    fontSize: "13px",
                                                    "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                      {
                                                        width: "0px !important",
                                                        padding:
                                                          "9px 0px !important",
                                                      },
                                                    "& .css-1nuss9t": {
                                                      width: "0px !important",
                                                      padding:
                                                        "9px 0px !important",
                                                    },
                                                    // "& input": {
                                                    //   textAlign: "center",
                                                    //   padding: "0px",
                                                    // },
                                                    width: "100%",
                                                  }}
                                                />
                                              </div>
                                            </>
                                          )}
                                          {exerData.parameters.includes(
                                            "Pace",
                                          ) ||
                                            (exerData.parameters.includes(
                                              "Vdot",
                                            ) && (
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  bottom: "4px",
                                                  left: "5px",
                                                }}
                                              >
                                                <Typography
                                                  variant="subtitle2"
                                                  sx={{
                                                    opacity: 0.6,
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                  }}
                                                >{` @ Speed ${getKmhrForPace(
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].distance
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].distance
                                                    : 0,
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].pace
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].pace
                                                    : 0,
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].distanceType
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].distanceType
                                                    : 0,
                                                )} km/hr or ${getMihrForPace(
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].distance
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].distance
                                                    : 0,
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].pace
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].pace
                                                    : 0,
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].distanceType
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].distanceType
                                                    : 0,
                                                )} mi/hr`}</Typography>
                                              </div>
                                            ))}
                                          {(exerData.parameters.includes(
                                            "Duration/Pace",
                                          ) ||
                                            exerData.parameters.includes(
                                              "Time",
                                            )) && (
                                            <div
                                              className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                            >
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                readOnly={true}
                                                placeholder="0"
                                                type="number"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ]?.time
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ]?.time
                                                    : ""
                                                }
                                                name="time"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label={
                                                  exerData.parameters.includes(
                                                    "Duration/Pace",
                                                  )
                                                    ? "Duration/Pace"
                                                    : "Time"
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  readOnly: true,
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="timeType"
                                                        value={
                                                          exerData.set[
                                                            selectedRound - 1
                                                          ]?.timeType
                                                        }
                                                        bel="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                        }}
                                                        readOnly={true}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="sec">
                                                          sec
                                                        </MenuItem>
                                                        <MenuItem value="min">
                                                          min
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                  marginTop: "5px",
                                                }}
                                              />
                                            </div>
                                          )}

                                          {exerData.parameters.includes(
                                            "Reps",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Reps"
                                                type="text"
                                                label="Reps"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ]?.reps
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ]?.reps
                                                    : ""
                                                }
                                                name="reps"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  // "& legend": { display: "none" },
                                                  // "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  // width: "13%",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Max_Reps",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Max Reps"
                                                type="text"
                                                label="Max Reps"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ]?.maxReps
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ]?.maxReps
                                                    : ""
                                                }
                                                name="maxReps"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  // "& legend": { display: "none" },
                                                  // "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  // width: "13%",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Watts",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Watts"
                                                type="number"
                                                label="Watts"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ]?.watts
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ]?.watts
                                                    : ""
                                                }
                                                name="watts"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Height",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ]?.height
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ]?.height
                                                    : ""
                                                }
                                                name="height"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label="Height"
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  readOnly: true,
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="height_unit"
                                                        value={
                                                          exerData.set[
                                                            selectedRound - 1
                                                          ]?.height_unit
                                                        }
                                                        label="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                          readOnly: true,
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="cm">
                                                          Cm
                                                        </MenuItem>
                                                        <MenuItem value="ft">
                                                          Feet
                                                        </MenuItem>
                                                        <MenuItem value="inch">
                                                          Inch
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Weight",
                                          ) && (
                                            <div className="col-12 col-md-4 col-lg-2 pe-0 py-2">
                                              <TextField
                                                sx={{
                                                  borderRadius: "5px",
                                                  paddingRight: 0,
                                                  width: "100%",
                                                }}
                                                size="small"
                                                id="custom-input"
                                                variant="outlined"
                                                placeholder="Weight"
                                                name="weight"
                                                label="Weight"
                                                value={
                                                  exerData?.set[
                                                    selectedRound - 1
                                                  ]?.weight
                                                    ? exerData?.set[
                                                        selectedRound - 1
                                                      ]?.weight
                                                    : ""
                                                }
                                                type="number"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  readOnly: true,
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="weightType"
                                                        value={
                                                          exerData.set[
                                                            selectedRound - 1
                                                          ]?.weightType
                                                        }
                                                        readOnly
                                                        label="Weight Type"
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                        }}
                                                      >
                                                        <MenuItem value="1rm">
                                                          % 1RM
                                                        </MenuItem>
                                                        <MenuItem value="body_weight">
                                                          % BW
                                                        </MenuItem>
                                                        <MenuItem value="kg">
                                                          KG
                                                        </MenuItem>
                                                        <MenuItem value="lb">
                                                          Pound
                                                        </MenuItem>
                                                        <MenuItem value="poods">
                                                          Poods
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Distance/Calories",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                sx={{
                                                  borderRadius: "5px",
                                                  paddingRight: 0,
                                                  width: "100%",
                                                }}
                                                size="small"
                                                id="custom-input"
                                                variant="outlined"
                                                placeholder={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].distanceType == "calories"
                                                    ? "Calories"
                                                    : "Distance"
                                                }
                                                name="distance"
                                                label="Distance/Calories"
                                                value={
                                                  exerData?.set[
                                                    selectedRound - 1
                                                  ]?.distance
                                                    ? exerData?.set[
                                                        selectedRound - 1
                                                      ]?.distance
                                                    : ""
                                                }
                                                type="number"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  readOnly: true,
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="distanceType"
                                                        value={
                                                          exerData.set[
                                                            selectedRound - 1
                                                          ]?.distanceType
                                                        }
                                                        readOnly
                                                        label="Weight Type"
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="m">
                                                          Meter
                                                        </MenuItem>
                                                        <MenuItem value="km">
                                                          KM
                                                        </MenuItem>
                                                        <MenuItem value="mi">
                                                          Mile
                                                        </MenuItem>
                                                        <MenuItem value="calories">
                                                          Calories
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "%MHR",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="%MHR"
                                                type="number"
                                                label="%MHR"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].mhr
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].mhr
                                                    : ""
                                                }
                                                name="mhr"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",

                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "RPE",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="RPE"
                                                label="RPE"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ].RPE
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ].RPE
                                                    : ""
                                                }
                                                name="RPE"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Tempo",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Tempo"
                                                type="number"
                                                label="Tempo"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ]?.tempo
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ]?.tempo
                                                    : ""
                                                }
                                                name="tempo"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",

                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Rest",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={
                                                  exerData.set[
                                                    selectedRound - 1
                                                  ]?.rest
                                                    ? exerData.set[
                                                        selectedRound - 1
                                                      ]?.rest
                                                    : ""
                                                }
                                                name="rest"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label="Rest"
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  readOnly: true,
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="restType"
                                                        value={
                                                          exerData.set[
                                                            selectedRound - 1
                                                          ]?.restType
                                                        }
                                                        label="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                          readOnly: true,
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="sec">
                                                          sec
                                                        </MenuItem>
                                                        <MenuItem value="min">
                                                          min
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </Tooltip>
                                    </div>
                                  )
                                  // ))
                                }
                              </Box>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                );
              })}
          </Box>
        </div>
      </div>
    </div>
  );
};
export default EMOMExercisesUI;
